// use client: useParams resolves which update to show from the URL
'use client'

import parse from 'html-react-parser'

import { Jumbotron } from '@/sections'

import '../personal.css'

import type { ServiceUpdate } from '@/types'

import { Col, Container, Row } from 'react-bootstrap'
import { useParams } from 'next/navigation'

import { PrimaryButton } from '@/components/buttons'

function ServiceUpdateDetail({ initialData }: { initialData?: ServiceUpdate[] }) {
  const { slug } = useParams()
  // Content comes from the build-time snapshot only. A Strapi publish rebuilds
  // and redeploys the site, so there is nothing to revalidate on mount.
  // See tests/no-client-cms-fetch.spec.ts.
  const serviceUpdatesList: ServiceUpdate[] = initialData ?? []

  const update = serviceUpdatesList.find(u => u.slug === slug)

  return (
    <section>
      <section className="section jumbotron">
        <Jumbotron title={`<span className="jumbotron-subtitle-2">Service</span> Updates`} />
      </section>
      <div className="service-update-details">
        {update && (
          <Container>
            <Row>
              <Col>
                <div className="border-bottom pb-2">
                  <h2>{update.title}</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="py-2">
                  <div className="d-flex flex-row-reverse">{update.date}</div>
                  <div className="py-4">
                    <div className="full-content-wrapper">{parse(update.content)}</div>
                  </div>

                  <div className="text-center my-4">
                    <PrimaryButton text="Back to Homepage" href="/" />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </section>
  )
}

export default ServiceUpdateDetail
